import CoverAbout from './CoverAbout';
export default CoverAbout;